import React, { useState } from 'react';
import { connect } from 'react-redux';
import * as Actions from '@cedalo/webui/src/actions/actions';
import { bindActionCreators } from 'redux';
import { useJSGNotification } from '@cedalo/webui/src/components/SheetDialogs/JSGHooks';
import { MachineDataDialogs } from './machinedata/MachineDataDownloader';
import { HttpServerSettingsDialog } from './http-server/HttpServerSettingsDialog';
import TimescaleImportDialog from './timescale/TimescaleImportDialog';

function mapDispatchToProps(dispatch) {
	return bindActionCreators({ ...Actions }, dispatch);
}

export const DialogExtensions = connect(
	(state) => ({
		appState: state.appState
	}),
	mapDispatchToProps
)(({ appState, setAppState }) => {
	// open/close state for each dialog:
	const [dialogState, setDialogState] = useState({
		[TimescaleImportDialog.TYPE]: false
	});
	// additional info for each dialog:
	const [dialogInfo, setDialogInfo] = useState({});


	const onClose = (type) => () => setDialogState({ [type]: false });
	
	const onShowTimescaleImportDialog = (notification = {}) => {
		setDialogInfo({ [TimescaleImportDialog.TYPE]: notification.object });
		setDialogState({ [TimescaleImportDialog.TYPE]: true });
	};

	const onShowFileDialog = () => {
		setAppState({ showMachineDataDialog: true })
	};

	// useJSGNotification('showFileDialog', onShowFileDialog);
	useJSGNotification('showDialog:File', onShowFileDialog);
	useJSGNotification(`showDialog:${TimescaleImportDialog.TYPE}`, onShowTimescaleImportDialog);

	return (
		<React.Fragment>
			<MachineDataDialogs open={appState.showMachineDataDialog} />
			{appState.showHttpServerSettingsDialog ? (
				<HttpServerSettingsDialog open={appState.showHttpServerSettingsDialog} />
			) : null}
			<TimescaleImportDialog
				open={dialogState[TimescaleImportDialog.TYPE]}
				info={dialogInfo[TimescaleImportDialog.TYPE]}
				onClose={onClose(TimescaleImportDialog.TYPE)}
			/>
		</React.Fragment>
	);
});



// WEBPACK FOOTER //
// /home/travis/build/cedalo/streamsheets-pro-features/packages/webui-extensions/src/DialogExtensions.js